import React from 'react';

import {translateAdditionalMarkup} from './translate';

export const sortByEvent = (events) => {
    const sortedEvents = {
        events: [],
        oldEvents: [],
    };

    if (!events) {
        return sortedEvents;
    }

    return events.reduce((list, event) => {
        const key = event.old ? 'oldEvents' : 'events';
        list[key].push(event);
        return list;
    }, {
        events: [],
        oldEvents: []
    });
};

export const sortByType = (events) => {
    const sortedEvents = {
        error: [],
        warning: [],
        success: [],
    };

    if (!events || typeof events.reduce !== 'function') {
        return sortedEvents;
    }

    return events.reduce((list, event) => {
        const type = event.type === 'fatal' ? 'error' : event.type;

        if (!list[type]) {
            return list;
        }

        list[type].push(event);
        return list;
    }, sortedEvents);
};

export const stats = (eventsByType) => {
    if (!eventsByType) {
        return null;
    }

    const {
        error: {length: elen},
        warning: {length: wlen},
        success: {length: slen}
    } = eventsByType;

    return {
        total: elen + wlen + slen,
        errors: elen,
        warnings: wlen,
        success: slen
    };
};

/* eslint-disable no-param-reassign */
export const oldEventsToTableRowArrays = (events, i18n) => events.map(({description, date, level, exception, additionalMarkup, progress}) => {
    const markupTranslator = translateAdditionalMarkup(i18n);
    description += '<br/>';
    if (progress !== undefined && progress !== -1) {
        description += `<br/>${i18n('system.error.progress.completed', progress)}`;
    }
    if (additionalMarkup) {
        description += markupTranslator(additionalMarkup);
    }
    description = <span dangerouslySetInnerHTML={{__html: description}} />;
    return [description, date, level, exception];
});



// WEBPACK FOOTER //
// ./src/johnson-events.js